export default "__VITE_ASSET__DTz68P30__"